<template>
<div class="product-modifiers-group-component">
  <div v-if="!shouldUseQuantityControls" class="product-modifiers-group-component product-variant-selector">
    <label :for="inputId" class="font-normal">
      {{ groupName }}
    </label>
    <VueSelect class="product-variant-select"
               v-model="value"
               :reduce="o => o.id"
               :options="modifiers"
               :id="inputId"
               label="name"
               :clearable="false"
               :searchable="true"
               :get-option-key="o => o.id"
               transition="fade"
    >
      <template #open-indicator="{ attributes }">
        <i class="fa fa-chevron-down" v-bind="attributes" />
      </template>
    </VueSelect>
  </div>
  <template v-else>
    <label class="text-black text-sm opacity-80 font-normal block mb-2">
      {{ groupName }}
    </label>
    <product-modifier v-for="modifier in productModifiersGroup.modifiers"
                      :key="`group-${group.id}-modifier-${modifier.modifier.id}`"
                      :product-modifier="modifier"
                      :nested="true"
                      :limit-reached="groupLimitReached"
                      class="mb-2"
                      v-model="selectedModifiers[modifier.modifier.id]"
    />
  </template>
</div>
</template>

<script>
import VueSelect from 'vue-select'
import ProductModifier from '@/components/products/partials/modifiers/ProductModifier'

export default {
  props: {
    productModifiersGroup: {
      required: true,
      type: Object,
    },

    preselectedModifiers: {
      required: false,
      type: Array,
      default:() => ([]),
    },
  },

  components: {
    VueSelect,
    ProductModifier,
  },

  mounted() {
    this.assignDefaultValue()
  },

  computed: {
    group() {
      return this.productModifiersGroup.group
    },

    groupName() {
      if (this.group.display_name) {
        return this.group.display_name
      }

      return this.group.name || ''
    },

    currentPreselectedModifier() {
      if (!this.preselectedModifiers.length) {
        return null
      }

      return this.preselectedModifiers.find(preselected => preselected.modifiers_group_id === this.productModifiersGroup.group.id)
    },

    modifiers() {
      const modifiers = this.productModifiersGroup.modifiers.map(modifier => ({
        id: modifier.modifier.id,
        name: (modifier.modifier.display_name ? modifier.modifier.display_name : modifier.modifier.name) || '',
      }))

      return [
        { id: '', name: '- Не выбрано -' },
        ...modifiers,
      ]
    },

    shouldUseQuantityControls() {
      return this.productModifiersGroup.max_quantity > 1
    },

    groupLimitReached() {
      const totalQuantity = this.selectedModifiersList.reduce((total, current) => current.quantity + total, 0)

      return totalQuantity >= this.productModifiersGroup.max_quantity
    },

    selectedModifiersList() {
      const modifiers = []

      for (let i in this.selectedModifiers) {
        if (!this.selectedModifiers.hasOwnProperty(i)) {
          continue
        } else if (!this.selectedModifiers[i].quantity) {
          continue
        }

        modifiers.push({
          modifier_id: this.selectedModifiers[i].modifier_id,
          modifiers_group_id: this.productModifiersGroup.group.id,
          quantity: this.selectedModifiers[i].quantity,
        })
      }

      return modifiers
    },
  },

  methods: {
    assignDefaultValue() {
      if (this.shouldUseQuantityControls) {
        this.pickFirstModifier()
      } else if (!!this.currentPreselectedModifier) {
        this.value = this.currentPreselectedModifier.modifier_id
      }

      this.$nextTick(() => this.$emit('initialized'))
    },

    pickFirstModifier() {
      if (!this.currentPreselectedModifier) {
        return
      }

      this.selectedModifiers[this.currentPreselectedModifier.modifier_id].quantity = this.currentPreselectedModifier.quantity
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.$emit('input', [{
          modifier_id: this.value,
          modifiers_group_id: this.productModifiersGroup.group.id,
          quantity: 1,
        }])
      },
    },

    selectedModifiers: {
      deep: true,
      handler() {
        this.$emit('input', this.selectedModifiersList)
      }
    },
  },

  data() {
    return {
      inputId: `product-modifiers-group-${Math.random().toString().replace('.', '_')}`,
      value: '',
      selectedModifiers: {},
    }
  }
}
</script>
